import React, { useState, useEffect } from 'react';
import { Card, Avatar, Typography, Button, Divider, List, Tag, Space, message, Upload, Modal, Row, Col } from 'antd';
import { UserOutlined, CrownOutlined, CalendarOutlined, UploadOutlined, SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../config';

const { Title, Text } = Typography;

const Profile = () => {
  const [userInfo, setUserInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [isRechargeModalVisible, setIsRechargeModalVisible] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const membershipPlans = [
    {
      name: '月度会员',
      price: 20,
      duration: '1个月',
      description: '适合短期使用',
      qrcode: '/qrcodes/monthly.png'
    },
    {
      name: '半年会员',
      price: 100,
      duration: '6个月',
      description: '超值优惠',
      qrcode: '/qrcodes/monthly.png'
    },
    {
      name: '年度会员',
      price: 200,
      duration: '12个月',
      description: '最优惠选择',
      qrcode: '/qrcodes/monthly.png'
    }
  ];

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    // 获取用户信息
    const fetchUserInfo = async () => {
      try {
        console.log('开始获取用户信息');
        const token = localStorage.getItem('token');
        console.log('当前token:', token);
        
        const response = await axios.get(`${config.apiBaseUrl}/api/user/profile`, {
          headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          withCredentials: true
        });
        
        console.log('获取用户信息成功:', response.data);
        console.log('头像URL:', response.data.avatar_url);
        console.log('完整头像URL:', response.data.avatar_url ? `${config.apiBaseUrl}${response.data.avatar_url}` : null);
        setUserInfo(response.data);
      } catch (error) {
        console.error('获取用户信息失败:', error);
        if (error.response) {
          console.error('错误响应:', error.response.data);
          if (error.response.status === 401) {
            message.error('登录已过期，请重新登录');
            navigate('/login');
          } else {
            message.error(error.response.data.message || '获取用户信息失败');
          }
        } else if (error.request) {
          console.error('请求错误:', error.request);
          message.error('无法连接到服务器，请检查网络连接');
        } else {
          console.error('其他错误:', error.message);
          message.error('获取用户信息失败，请稍后重试');
        }
      } finally {
        setLoading(false);
      }
    };

    fetchUserInfo();
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const handleAvatarUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) {
      message.error('请选择要上传的文件');
      return;
    }

    const token = localStorage.getItem('token');
    if (!token) {
      message.error('请先登录');
      navigate('/login');
      return;
    }

    const formData = new FormData();
    formData.append('avatar', file);

    try {
      console.log('开始上传头像');
      console.log('当前token:', token);
      
      const response = await axios.post(`${config.apiBaseUrl}/api/upload-avatar`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });
      
      console.log('头像上传成功:', response.data);
      message.success('头像上传成功');
      
      // 更新用户信息
      console.log('开始获取更新后的用户信息');
      const userInfoResponse = await axios.get(`${config.apiBaseUrl}/api/user/profile`, {
        headers: { 
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      console.log('获取用户信息成功:', userInfoResponse.data);
      setUserInfo(userInfoResponse.data);
    } catch (error) {
      console.error('头像上传失败:', error);
      if (error.response) {
        console.error('错误响应:', error.response.data);
        if (error.response.status === 401 || error.response.status === 422) {
          message.error('登录已过期，请重新登录');
          localStorage.removeItem('token');
          navigate('/login');
        } else {
          message.error(error.response.data.message || '头像上传失败');
        }
      } else if (error.request) {
        console.error('请求错误:', error.request);
        message.error('无法连接到服务器，请检查网络连接');
      } else {
        console.error('其他错误:', error.message);
        message.error('头像上传失败，请稍后重试');
      }
    }
  };

  const handleRecharge = (plan) => {
    setSelectedPlan(plan);
    setIsRechargeModalVisible(true);
  };

  const RechargeModal = () => (
    <Modal
      title="会员充值"
      open={isRechargeModalVisible}
      onCancel={() => setIsRechargeModalVisible(false)}
      footer={null}
      width={600}
    >
      <div style={{ textAlign: 'center', padding: '20px' }}>
        <Title level={4}>{selectedPlan?.name}</Title>
        <Text type="danger" style={{ fontSize: '24px', marginBottom: '20px', display: 'block' }}>
          ¥{selectedPlan?.price}
        </Text>
        <Text style={{ display: 'block', marginBottom: '20px' }}>
          {selectedPlan?.description}
        </Text>
        <img 
          src={selectedPlan?.qrcode} 
          alt="支付二维码" 
          style={{ width: '200px', height: '200px', marginBottom: '20px' }}
        />
        <div style={{ 
          border: '1px solid #ff4d4f', 
          borderRadius: '4px', 
          padding: '15px', 
          marginBottom: '10px',
          color: '#333'
        }}>
          <Text>
            请使用微信扫描二维码完成支付，支付成功后，请联系管理员(VX:gothictears)开通会员
          </Text>
        </div>
      </div>
    </Modal>
  );

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        background: '#f5f5f7'
      }}>
        <div className="loading-spinner" />
      </div>
    );
  }

  return (
    <div style={{ padding: '24px', maxWidth: '1200px', margin: '0 auto' }}>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <Card>
          <Space size="large" style={{ width: '100%', justifyContent: 'space-between' }}>
            <Space>
              <Avatar 
                size={64} 
                src={userInfo?.avatar_url ? `${config.apiBaseUrl}${userInfo.avatar_url}` : null}
                icon={<UserOutlined />}
                onError={() => {
                  console.error('头像加载失败:', userInfo?.avatar_url ? `${config.apiBaseUrl}${userInfo.avatar_url}` : null);
                }}
              />
              <Space direction="vertical">
                <Title level={4} style={{ margin: 0 }}>{userInfo?.username}</Title>
                <Text type="secondary">{userInfo?.email}</Text>
              </Space>
            </Space>
            <Space>
              <Button 
                type="primary" 
                icon={<CrownOutlined />}
                onClick={() => handleRecharge(membershipPlans[0])}
              >
                开通会员
              </Button>
              <Button 
                icon={<UploadOutlined />}
                onClick={() => document.getElementById('avatar-upload').click()}
              >
                更换头像
              </Button>
            </Space>
          </Space>
        </Card>

        <Card title="会员信息">
          <Space direction="vertical" style={{ width: '100%' }}>
            <Row justify="space-between">
              <Col>
                <Text>会员状态：</Text>
                <Text type={userInfo?.is_member ? "success" : "secondary"}>
                  {userInfo?.is_member ? '已开通' : '未开通'}
                </Text>
              </Col>
              {userInfo?.is_member && (
                <Col>
                  <Text>到期时间：</Text>
                  <Text type="success">{userInfo?.membership_expiry}</Text>
                </Col>
              )}
            </Row>
            {!userInfo?.is_member && (
              <div style={{ marginTop: '20px' }}>
                <Title level={5}>会员套餐</Title>
                <Row gutter={[16, 16]}>
                  {membershipPlans.map((plan, index) => (
                    <Col span={8} key={index}>
                      <Card 
                        hoverable 
                        onClick={() => handleRecharge(plan)}
                        style={{ textAlign: 'center' }}
                      >
                        <Title level={4}>{plan.name}</Title>
                        <Text type="danger" style={{ fontSize: '20px' }}>
                          ¥{plan.price}
                        </Text>
                        <div style={{ marginTop: '10px' }}>
                          <Text type="secondary">{plan.duration}</Text>
                        </div>
                        <div style={{ marginTop: '5px' }}>
                          <Text type="secondary">{plan.description}</Text>
                        </div>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </div>
            )}
          </Space>
        </Card>

        <Card title="使用统计">
          <Space direction="vertical" style={{ width: '100%' }}>
            <Row justify="space-between">
              <Col>
                <Text>今日搜索次数：</Text>
                <Text>{userInfo?.daily_search_count || 0}/30</Text>
              </Col>
              <Col>
                <Text>搜索次数重置：</Text>
                <Text>每天凌晨</Text>
              </Col>
            </Row>
          </Space>
        </Card>
      </Space>

      <input
        type="file"
        id="avatar-upload"
        style={{ display: 'none' }}
        accept="image/*"
        onChange={handleAvatarUpload}
      />

      <RechargeModal />
    </div>
  );
};

export default Profile;